(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-grid"] && !Shopify.designMode) return;
  try {
    
  const initializePortfolioGrid = (root) => {
    if (!root || root.dataset.portfolioReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-portfolio-filter]'));
    const items = Array.from(root.querySelectorAll('[data-portfolio-category]'));

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.portfolioFilter;
        const updateGrid = () => {
          buttons.forEach((filterButton) => {
            const isActive = filterButton === button;
            filterButton.classList.toggle('is-active', isActive);
            filterButton.setAttribute('aria-pressed', String(isActive));
          });
          items.forEach((item) => {
            item.hidden = filter !== 'all' && item.dataset.portfolioCategory !== filter;
          });
        };

        if (document.startViewTransition) {
          document.startViewTransition(updateGrid);
        } else {
          updateGrid();
        }
      });
    });

    root.dataset.portfolioReady = 'true';
  };

  document.querySelectorAll('[data-portfolio-grid]').forEach(initializePortfolioGrid);
  document.addEventListener('shopify:section:load', (event) => {
    initializePortfolioGrid(event.target.querySelector('[data-portfolio-grid]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-media-gallery"] && !Shopify.designMode) return;
  try {
    
  const initializeProjectMedia = (root) => {
    if (!root || root.dataset.projectMediaReady === 'true') return;

    const triggers = Array.from(root.querySelectorAll('[data-project-lightbox-trigger]'));
    const dialog = root.querySelector('[data-project-lightbox]');
    const image = root.querySelector('[data-project-lightbox-image]');
    const counter = root.querySelector('[data-project-lightbox-counter]');
    const viewport = root.querySelector('[data-project-lightbox-viewport]');
    const closeButton = root.querySelector('[data-project-lightbox-close]');
    const previousButton = root.querySelector('[data-project-lightbox-previous]');
    const nextButton = root.querySelector('[data-project-lightbox-next]');
    let activeIndex = 0;

    if (!triggers.length || !dialog || !image) return;

    const showImage = (index) => {
      activeIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[activeIndex];
      image.classList.remove('is-zoomed');
      image.src = trigger.dataset.projectLightboxSrc;
      image.alt = trigger.dataset.projectLightboxAlt || '';
      if (counter) counter.textContent = `${activeIndex + 1} / ${triggers.length}`;
      if (viewport) {
        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
      }
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        showImage(index);
        dialog.showModal();
      });
    });

    closeButton?.addEventListener('click', () => dialog.close());
    previousButton?.addEventListener('click', () => showImage(activeIndex - 1));
    nextButton?.addEventListener('click', () => showImage(activeIndex + 1));

    image.addEventListener('click', () => {
      image.classList.toggle('is-zoomed');
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });

    root.dataset.projectMediaReady = 'true';
  };

  document.querySelectorAll('[data-project-media]').forEach(initializeProjectMedia);
  document.addEventListener('shopify:section:load', (event) => {
    initializeProjectMedia(event.target.querySelector('[data-project-media]'));
  });

  } catch(e) { console.error(e); }
})();
})();
